import { mockRepository } from './mock';
import { supabaseRepository } from './supabase';
import type { DataRepository } from './types';

/**
 * Selects the active data backend from `VITE_DATA_SOURCE`:
 *   - "mock"      → typed in-memory data (default; runs with no backend)
 *   - "supabase"  → live Postgres via the Supabase client
 *
 * Feature code imports `repository` only — never a concrete impl — so a
 * backend swap is a one-line env change.
 */
const source = import.meta.env.VITE_DATA_SOURCE ?? 'mock';

export const repository: DataRepository = source === 'supabase' ? supabaseRepository : mockRepository;

export type { DataRepository } from './types';
export type { CertificateVerification } from './types';
